"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["3 months or less", "4 to 6 months", "7 months or more", "No time frame", "Unknown"];
exports.default = _default;
//# sourceMappingURL=purchase_timeframe.js.map